<template>
    <div 
        @scroll="continuesscroll"
        class="orderHistoryList">
          
        <mobile-order-history 
            v-if="['xs','sm','md'].includes(windowsize.breakpoint)"
            :amendingorder.sync="amendingorder"
            :changestatus.sync="changestatus"
            :groupedhistory="groupedhistory"/>
          
        <desktop-order-history 
            v-if="['lg','xl','xxl'].includes(windowsize.breakpoint)"
            :amendingorder.sync="amendingorder"
            :changestatus.sync="changestatus"
            :groupedhistory="groupedhistory"/>
          

        <b-modal 
            id="amendorder" 
            centered
            hide-footer 
            hide-header>

            <img src="@/assets/cancelOrder.png" alt="">

            <h1>Amend Delivery?</h1>

            <div class="orderTrail" v-if="amendingorder">
                <div class="orderTrailItem">
                    <span 
                        :class="[`trailType`, 'done']">
                        <b-icon icon="box-seam"></b-icon>
                    </span>

                    <div class="trailDetails">
                        <h4>Delivered</h4>

                        <p>{{delivereddate(amendingorder) | forceformatdate('h:mm A, MMM D YYYY')}}</p>

                    </div>
                </div>
            </div>

            <p>This will only change the status of the order. You will still be assigned and responsible to finish the delivery.</p>

             <b-form-textarea
                v-model="amendingnotes"
                placeholder="Write..."
                ></b-form-textarea>

             <b-form-checkbox
                v-if="changestatus"
                v-model="ischangestatus"
                :value="true"
                :unchecked-value="false"
                >
                Change delivery status
             </b-form-checkbox>


            <div class="modalAction">
                <button 
                    @click.prevent="$bvModal.hide('amendorder')"
                    class="btn btn-outline-primary">NEVER MIND</button>

                <button 
                     @click.prevent="startamendingorder"
                    class="btn btn-primary">CONTINUE</button>
            </div>
        </b-modal>
    </div>
</template>

<script>
/**
 * Declerations
 */
// Plugins 
import axios from 'axios'
import moment from 'moment'

// helpers
import {getCollections, cleanrecord, addUpdateCollection} from '@/helpers/localbase'
import Helper from '@/helpers/helper'

// mixins
import {ordermixins} from '@/mixins/ordermixins'
import {orderboxmixins} from "@/mixins/orderboxmixins"

//components
import mobileorderhistory from '@/components/employee/mobileorderhistory'
import desktoporderhistory from '@/components/employee/desktoporderhistory'

export default {
    mixins : [ordermixins, orderboxmixins],
    components : {
        'mobile-order-history' : mobileorderhistory,
        'desktop-order-history' : desktoporderhistory
    },
    data() {
        return {
            currentpage   : 1,
            maxpage       : 1,
            fetching      : false,
            groupedhistory: [],
            amendingorder : null,
            expandflavor  : null,
            amendingnotes : '',
            changestatus  : false,
            ischangestatus : true
        }
    },
    computed : {
        /**
         * Windows size
         */
        windowsize() {
            return this.$store.state.windowsize
        },
        /**
         * Network status
         */
        isonline() {
            return this.$store.state.isonline
        },
        /**
         * Employer history
         */
        history : {
            get() {
                return this.$store.state.employeeshistory
            },
            set(list) {
                this.$store.commit('updateemployeeshistory', list)
            }
        },
        /**
         * Webhook
         */
        socketio () {
            return this.$store.state.socketio
        }
    },
    filters : {
        /**
         * Format date by 
         * @param format
         */
        formatdate(date, format) {
            return date ? Helper.formatdate(date, format) : ''
        },
        /**
         * Force format date by 
         * @param format
         */
        forceformatdate(date, format) {
            return date ? Helper.formatdate(date, format, true) : ''
        },
        /**
         * Format date by relation like
         * Today, Tomorrow, and MM/DD/YYYY
         */
        formatreldate(date) {
            return Helper.datestring(date)
        }
    },
    methods : {
        /**
         * Get delivered date
         */
        delivereddate(order) {
            const status = order.order.orderstatuses.find(s => s.status == 'delivered');

            return status ? status.created_at : ''
        },
       
        /**
         * Amend order
         */
        async startamendingorder() {
            this.$bvModal.hide('amendorder')
            const url = `/update_order_status/${this.amendingorder.order.id}`

            await axios.post(url, {
                status             : 'amend',
                amend_change_status: this.ischangestatus,
                notes              : this.amendingnotes
            })
            
            /**
             * Check if change status 
             * then update delivery list
             */
            if(this.ischangestatus) {
                this.$emit('getdeliverylist')
            }


            // ressts
            this.amendingnotes = ''
            this.amendingorder = null

            
            this.getemployeeshistory();

            
            if(this.socketio) {
                this.socketio.emit('broadcast', {
                    type    : 'amedorder',
                    updateto: 'manager',
                })
            }
        },
        /**
         * Continues scroll fetching more history data
         */
        continuesscroll(){
            console.log('scrolling', this.maxpage , this.currentpage)
            if(this.maxpage >= this.currentpage) {
                if(!this.fetching) {
                    this.getemployeeshistory(true)
                }
            }
        },
       
        /** 
         * Group history by date
        */
        historygrouping() {
            let   newlist = [];
            const format  = 'MM/DD/YYYY'

            this.history.forEach(order => {
                /**
                 *
                 * Check if order is nested or not
                 * 
                 */
                let orderdata = order;


                if(order.order) {
                    orderdata = order.order
                }  
                // moment(orderdata.updated_at).format(format)
                const date  = Helper.formatdate(orderdata.updated_at, format, true);
                const group = newlist.find(g => moment(g.date).isSame(date, 'day'));

                console.log(newlist, 'groupgroup', group, date)


                if(group) {
                    newlist = newlist.map(g => {
                        if(moment(g.date).isSame(date, 'day')) {
                            g.orders = [...g.orders, order];
                        }
                        return g;
                    })
                } else {
                    const newgroup = {
                        date     : date,
                        orders   : [order]
                    }

                    newlist = [...newlist, newgroup]
                }
            })


            return newlist.slice().sort((a, b) => new Date(b.date) - new Date(a.date));
        },
        /**
         * Get employer history
         * Pull from indexed db first
         */
        async getemployeeshistory(page = false) {
                this.fetching = true
            let ihistory      = []

            if(this.history.length == 0 && !page) {
                 ihistory     = await getCollections({name : 'employeeshistory'})
                 this.history = ihistory
            }

            const url = page ? `/get_driver_orders?page=${this.currentpage + 1}` : `/get_driver_orders`
            const res = await axios.get(url).catch(err => console.log(err))

            /**
             * Check if fetching pages or just loaded
             */
            this.history = !page ? [] : this.history

            if(res.data) {
                /**
                 * Merge history data 
                 * and check duplicate data and remove not assigned order
                 */
                const ahistory = [...this.history, ...res.data.data].filter((item, index, array) => index === array.findIndex(i => i.id == item.id));

                this.history = ahistory;
                
                /**
                 * Get page data
                 */
                this.currentpage = res.data.current_page
                this.maxpage     = res.data.last_page

                for (let index = 0; index < ahistory.length; index++) {
                    const history = ahistory[index];
                    addUpdateCollection({name : "employeeshistory",  data : history});
                }

                /**
                 * Clean up records
                 * For tash data
                 */
                cleanrecord(ahistory, ihistory, 'id', 'employeeshistory')

            } 

            /**
             * Resets
             */

            this.fetching       = false
            this.groupedhistory = this.historygrouping();

        }
    },
    /**
     * Run function before component render
     */
    beforeMount() {
        // get history
        this.getemployeeshistory()
    }
}

</script>

<style lang="scss">
@import "@/scss/partials/_colors.scss";
@import "@/scss/partials/_mixins.scss";

.orderHistoryList {
    max-height: 87vh;
    overflow  : hidden auto;

    .historyItem {
        padding-top: 30px;
        border-bottom: 10px solid $lightgrey;

        h1 {
            font-size: 20px;
            font-weight: 700;
            color: $primaryColor;
        }
    }

    .deliveryProof{
        margin-bottom: 20px;
        height       : auto;
        
        img {
            width       : 100%;
            max-width   : 300px;
            margin-left : auto;
            margin-right: auto;
            display     : table;
        }
    }


    .orderTrail {
        padding-left : 30px;

        .amendstatuses {
            svg {
                font-size : 14px;
            }
            
            .orderstatus {

        
                p {
                    text-transform: none;
                }
            }
        }

        .orderTrailItem {
            display    : flex;
            border-left: 1px solid $lightgrey2;
            
            &:last-child {
                border : none;
            }

            .trailType {
                width           : 50px;
                height          : 50px;
                flex            : 0 0 50px;
                margin-right    : 15px;
                margin-left     : -25px;
                border-radius   : 100%;
                display         : flex;
                align-items     : center;
                justify-content : center;
                background-color: $lightgrey;
                font-size       : 25px;

                &.done {
                    background-color: $primaryColor;
                    color           : white;
                }
            }

            .trailDetails {
                h4 {
                    font-size    : 20px;
                    font-weight  : 700;
                    margin-bottom: 0;
                }
            }

            .trailAction {
                .btn {
                    width  : 130px;
                    height : 40px;
                    padding: 0;
                }
            }
        }
    }

    .historyTrail {
        display: flex;
        padding-top: 15px;
        padding-bottom: 15px;

        .trailTime {
            color: $grey;
            margin-right: 15px;
            display: block;
            white-space: nowrap;
        }

        .tailDetails {
            display: flex;
            width  : 100%;

            .deliveryImage {
                flex               : 0 0 50px;
                width              : 50px;
                height             : 50px;
                display            : block;
                border-radius      : 100%;
                background-size    : cover;
                background-position: center;
                margin-right       : 15px;

                 svg {
                    border-radius: 100%;
                    width        : 100%;
                    height       : 100%;
                    border       : 1px solid $grey;
                    padding      : 15px;
                }
            }

            h3 {
                font-size: 18px;
                font-weight: 700;
                margin-bottom: 0;
            }

            p {
                color: $grey;
                margin-bottom: 0;
            }
        }
    }

    .collapse {
        &.show {
            border-bottom : 10px solid $lightgrey;
        }
    }

    .accordion {
        .card {
            header {

                .collapseIcon {
                    flex : 0 0 30px;
                    visibility: visible;

                    svg {
                        margin-left: auto;
                    }
                }

                .historyDetail {
                    flex : 1;
                }

                .collapsed {
                    svg {
                        &:first-child {
                            display: none;
                        }
                    }
                }

                .not-collapsed {
                    width : 100%;
                    
                    .deliveryImage {
                        // display: none;
                    }

                    svg {
                        &:last-child {
                            display: none;
                        }
                    }
                }
            }
        }
    }

    .accordion {
        .card {
            header {

                .collapseIcon {
                    flex : 0 0 30px;
                    visibility: visible;

                    svg {
                        margin-left: auto;
                    }
                }

                .historyDetail {
                    flex : 1;
                }

                .collapsed {
                    svg {
                        &:first-child {
                            display: none;
                        }
                    }
                }

                .not-collapsed {
                    width : 100%;
                    
                    .deliveryImage {
                        // display: none;
                    }

                    svg {
                        &:last-child {
                            display: none;
                        }
                    }
                }
            }
        }
    }

    .orderContactDetails {
        border-top   : 1px solid $lightgrey2;
        border-bottom: 1px solid $lightgrey2;
        padding      : 30px 0;
        color        : $grey;

        .contactItem {
            margin-bottom : 10px;

            .orderNote {
                background-color: lighten($color: $primaryColor, $amount: 59);
                padding         : 15px;
            }
        }
    }

    .orderSummary {
        padding-top : 30px;

        .orderSummaryHeader {
            margin-bottom : 20px;

            h4 {
                font-size    : 18px;
                font-weight  : 800;
                margin-bottom: 0;
            }

            .dozen {
                font-weight: 800;
                color      : $grey;
                text-align: left;
            }
        }

        .orderBreakdown {
            padding-left : 15px;

            .orderBreakdownItem {
                color        : $primaryColor;
                font-size    : 15px;
                margin-bottom: 10px;
                
                .orderNumber {
                    font-weight: 700;
                }
            }
        }
    }

    .orderBreakdown {
        .orderBreakdownItem {
            cursor     : pointer;
            
            .orderboxheader {
                display    : flex;
                align-items: center;
    
                .b-icon.bi {
                    font-size : 12px;
                }
    
                .orderNumber {
                    margin-right : 10px;
                }
    
                .boxname {
                    margin-left : 10px;
                    font-weight : 600;
                    margin-right: 10px;
                }
            }

            .flavorlist {
                padding-left : 30px;

                .flavorname {
                    &::before {
                        content     : '●';
                        margin-right: 10px;
                    }
                }

            }
        }

    }
}

#amendorder {
    img {
        margin-left : auto;
        margin-right: auto;
        display     : block;
    }

    .modal-body {
        padding-left : 30px;
        padding-right: 30px;
        text-align   : center;
        
    }

    .orderTrail {
        display        : flex;
        justify-content: center;
        padding-left   : 0;

        .orderTrailItem {
            display   : block;
            text-align: center;

            .trailType {
                margin-right    : auto;
                margin-left     : auto;
                width           : 35px;
                height          : 35px;
                font-size       : 15px;
                border-radius   : 100%;
                display         : flex;
                align-items     : center;
                justify-content : center;
                background-color: $lightgrey;

                &.done {
                    background-color: $primaryColor;
                    color           : white;
                }
            }
        }
    }
}
</style>
